var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"board"},[_c('board-controller')],1),_c('div',{staticClass:"players"},_vm._l(([0,1,2,3]),function(i){return _c('div',{key:i,staticClass:"player"},[_c('player-controller')],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }